/**
 * @fileoverview 所有电站币种和时区等信息
 */
import { useRequest } from 'ahooks';
import { requestGet } from '@common/utils/request.js';
import { getCurrentOrganizationId } from 'utils/utils';

export default function InitHooks() {
  return () => (next) => async(action) => {
    if (!action) {
      return next(action);
    }
    // 需要try-catch,避免emitter事件监听器中抛出的异常，引起dva崩溃
    try {
      const { type = '', payload = {} } = action;
      if (['global/fetchMenuInfo/@@start'].includes(type)) {
        const organizationId = await getCurrentOrganizationId();
        console.log('fxrtest', type, organizationId);
        requestGet(`/station/v1/${organizationId}/station-infos/queryCurrency`,{},
        {
          noError: true,
          noSuccess: true,
        }).then(resArr=>{
          if (resArr) {
            sessionStorage.setItem('kStationCurrencyArr', JSON.stringify(resArr));
          }
        })
      }
    } catch (err) {
      /** noop */
    }
    return next(action);
  };
}
